export const renderBullet = (index, className) => '<span class="' + className + '"></span>'
